export { default } from './RemoteSVGWeb';
export * from './RemoteSVGWeb';
